import Image from 'next/image'
import {FC} from 'react'

import {TrademarkImage} from '@/components/common/content/TrademarkImage'
import {DocumentLocation} from '@/utils/document/types'
import {USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

export type FormSummaryTrademarkLogoProps = {
  imageFileSrc?: string
  logoDocument?: DocumentLocation
  height?: string
}

export const FormSummaryTrademarkLogo: FC<FormSummaryTrademarkLogoProps> = ({
  imageFileSrc,
  logoDocument,
  height,
}) => (
  <>
    <div className="logo">
      {imageFileSrc ? (
        <Image
          src={imageFileSrc}
          alt="Trademark logo"
          style={{objectFit: 'contain'}}
          fill
          sizes="100vw"
        />
      ) : logoDocument ? (
        <TrademarkImage logoDocument={logoDocument} />
      ) : null}
    </div>

    <style jsx>{`
      .logo {
        position: relative;
        width: 100%;
        height: ${height ?? '128px'};
        margin: 0 auto;
      }
      @media ${USER_TABLET_SCREENSIZE} {
        .logo {
          height: 64px;
        }
      }
    `}</style>
  </>
)
